export default {"src":"/_next/static/media/icon_checkbox_on1.6c0d9cc0.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};